import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { getAuthToken } from "./AuthTokenHandler";
import { UserDetailsContext } from "App";

export function PrivateRoute({ children, redirectUrl }) {
  const userDetails = useContext(UserDetailsContext);
  const isAuthenticated = userDetails?.isAuthenticated;
  const token = getAuthToken();

  //console.log("isAuthenticated in PrivateRoute " + isAuthenticated);

  if (isAuthenticated || token) {
    return children;
  }

  return <Navigate to={redirectUrl} replace />;
}

export function PublicRoute({ children, redirectUrl, baseUrl }) {
  const userDetails = useContext(UserDetailsContext);
  const isAuthenticated = userDetails?.isAuthenticated;
  const token = getAuthToken();

  //console.log("isAuthenticated in PublicRoute " + isAuthenticated);

  if (!isAuthenticated && !token) {
    return children;
  }

  return <Navigate to={baseUrl} replace />;
}